// Copyright 2020 Cartesi Pte. Ltd.
export const loadEnemies = () => {
    return require('./resources/enemies.json');
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5lbXkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW5lbXkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsbUNBQW1DO0FBY25DLE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxHQUFvQyxFQUFFO0lBQzdELE9BQU8sT0FBTyxDQUFDLDBCQUEwQixDQUFDLENBQUM7QUFDL0MsQ0FBQyxDQUFDIn0=